import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CronJobList from '../components/CronJobList';
import CronJobForm from '../components/CronJobForm';
import UpdateCronJob from '../components/UpdateCronJob';
import CronLogs from '../components/CronLogs';
import Login from '../components/Login';
import ProtectedRoute from './ProtectedRoute';
import { useSelector } from 'react-redux';

const AppRoutes = () => {
  const { token } = useSelector((state) => state.auth);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoute token={token} />}>
          <Route path="/" element={<CronJobList />} />
          <Route path="/create" element={<CronJobForm />} />
          <Route path="/edit/:id" element={<UpdateCronJob />} />
          <Route path="/cron-logs" element={<CronLogs />} />
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
